// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedoverrides.floorplans.RentalManagerUserPropertyFeedFloorPlanWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create,
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete,
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFeedFloorPlanCreateRequestDto,
  UserPropertyFeedFloorPlanCreateResponseWebDto,
  UserPropertyFeedFloorPlanDeleteRequestDto,
  UserPropertyFeedFloorPlanEditRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Args {
  postData: UserPropertyFeedFloorPlanCreateRequestDto;
}

export type RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyFeedFloorPlanCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Args
>;

/**
 * Create a floor plan override on a feed listing
 */
export const useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Args) =>
      RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Args {
  postData: UserPropertyFeedFloorPlanDeleteRequestDto;
}

export type RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Args
>;

/**
 * Delete a floor plan override on a feed listing
 */
export const useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Args {
  postData: UserPropertyFeedFloorPlanEditRequestDto;
}

export type RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Args
>;

/**
 * Edit a floor plan override on a feed listing
 */
export const useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Args) =>
      RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit(args.postData, httpClient),
  });
};
